const locationService = (function () {

    let location = {
        fylke: null,
        kommune: null,
        sted: null,
        lat: null,
        lng: null
    }, initialized = false, cookie = '_geo';

    function init() {
        if (initialized === true) {
            return;
        }
        initialized = true;
        let loc = getCookie(cookie);

        if (loc) {
            try {
                loc = JSON.parse(decodeURI(loc));
                setLocation(loc);
            } catch(e) {
            }
        }
    }

    function setLocation(data) {
        let dirty = false;

        Object.keys(data).forEach(function (key) {
            if (key in location && data[key] !== location[key]) {
                location[key] = data[key];
                dirty = true;
            }
        });

        if (dirty === true) {
            saveCookie();
        }
    }

    function saveCookie() {
        setCookie(cookie, encodeURI(JSON.stringify(location)), 1);
    }

    function get(name) {
        init();
        return location[name] || '';
    }

    function set(name, value) {
        let o = {};
        o[name] = value;
        setLocation(o);
    }

    function getLast(none) {
        if (typeof none !== 'string') {
            none = '';
        }

        return locationService.getSted() || locationService.getKommune() || locationService.getFylke() || none;
    }

    function getPath() {
        return [locationService.getFylke(), locationService.getKommune(), locationService.getSted()]
            .filter(x => x)
            .join('/');
    }

    function hasCoordinates() {
        return location.lat && location.lng;
    }

    return {
        get: get,
        getLocation: () => {
            init();
            return location;
        },
        getPath: getPath,
        hasCoordinates: hasCoordinates,
        hasLocation: () => hasCoordinates() || getLast('') !== '',
        setLocation: data => {
            init();
            setLocation(data);
        },
        set: set,
        init: init,
        getLast: getLast,
        getFylke: () => locationService.get('fylke'),
        getArea: () => locationService.get('fylke'),
        getKommune: () => locationService.get('kommune'),
        getPlace: () => locationService.get('kommune'),
        getSted: () => locationService.get('sted'),
        getCitypart: () => locationService.get('sted')
    };

}(setCookie, getCookie));

(function () {

    const geoCode = (position, $box) => {
        let geocoder = new google.maps.Geocoder;
        let parse = function (results, level) {
            let result = '';
            results.map(function (r) {
                r.address_components.map(function (c) {
                    let f = c.types.indexOf(level);
                    if (f !== -1) {
                        result = c.long_name.replace(/\sMunicipality/, '');
                    }
                });
            });

            return result;
        };


        geocoder.geocode({
                'location': {
                    lat: parseFloat(position.coords.latitude),
                    lng: parseFloat(position.coords.longitude)
                }
            },
            function (results, status) {

                buttonize($box, false);

                let cookieData = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    fylke: parse(results, "administrative_area_level_1"),
                    kommune: parse(results, "administrative_area_level_2"),
                    sted: parse(results, 'sublocality_level_1')
                };

                locationService.setLocation(cookieData);

                $('#locationBox').find('.place_name').text(locationService.getLast('Ikke valgt'));
                $('.ratingList h4 strong').html(locationService.getLast('Norge'));

                getTop5();
                _initChangeImage(true);
            });
    };

    if ("geolocation" in navigator) {

        if (!locationService.getFylke()) {
            let $box = $('#locationBox').find('strong');

            buttonize($box);

            /* geolocation is available */
            navigator.geolocation.getCurrentPosition(function (position) {

                initGoogleMaps().then(() => {
                    geoCode(position, $box);
                }).catch(e => {})

            }, () => buttonize($box, false));
        }
    } else {
        console.error("I'm sorry, but geolocation services are not supported by your browser.");
    }
})();


